<template>
      <b-form @submit.prevent="onSubmit" v-if="show">
      <check-in-screen :title="$t('resume.title')" :step="5">
          <div class="row">
              <b-form-group
                class="col-12 col-sm-6"
                id="input-reservacion"
                :label="$t('resume.reservation')"
                label-for="reservacion"
              >
                <b-form-input
                  id="reservacion"
                  v-model="reservacion"
                  type="text"
                  required
                  placeholder=""
                  disabled
                  size="sm"
                ></b-form-input>
              </b-form-group>

              <b-form-group
                class="col-12 col-sm-6"
                id="input-fecha-reservacion"
                :label="$t('resume.reservationDate')"
                label-for="fecha-reservacion">
                <b-form-input
                  id="fecha-reservacion"
                  v-model="fechaReservacion"
                  required
                  placeholder=""
                  disabled
                  size="sm"
                ></b-form-input>
              </b-form-group>

              <b-form-group
                class="col-12 col-sm-6"
                id="input-entrada"
                :label="$t('resume.entry')"
                label-for="entrada"
              >
                <b-form-input
                  id="entrada"
                  v-model="entrada"
                  type="text"
                  required
                  placeholder=""
                  disabled
                  size="sm"
                ></b-form-input>
              </b-form-group>

              <b-form-group
                class="col-12 col-sm-6"
                id="input-salida"
                :label="$t('resume.departure')"
                label-for="salida">
                <b-form-input
                  id="salida"
                  v-model="salida"
                  required
                  placeholder=""
                  disabled
                  size="sm"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                class="col-12 col-sm-6"
                id="input-habitaciones"
                :label="$t('resume.roomsNumber')"
                label-for="habitaciones">
                <b-form-input
                  id="habitaciones"
                  v-model="habitaciones"
                  required
                  placeholder=""
                  disabled
                  size="sm"
                ></b-form-input>
              </b-form-group>
                <h5 class="col-12 section-title">{{$t('personalInformation.titleInfo')}}</h5>
                <b-form-group
                  class="col-12"
                  id="input-nombre-completo"
                  :label="$t('personalInformation.fullName')"
                  label-for="nombre-completo">
                  <b-form-input
                      :disabled="true"
                      id="nombre-completo"
                      size="sm"
                      v-model.trim="nombreCompleto"
                      placeholder=""
                  ></b-form-input>
                  </b-form-group>
                  <b-form-group
                  class="col-12 col-sm-6"
                  id="input-group-2"
                  :label="$t('personalInformation.email')"
                  label-for="correo">
                  <b-form-input
                      :disabled="true"
                      id="correo"
                      size="sm"
                      v-model.trim="correo"
                      placeholder=""
                  ></b-form-input>
                  </b-form-group>
                  <b-form-group
                  class="col-12 col-sm-6"
                  id="input-group-2"
                  :label="$t('personalInformation.phone')"
                  label-for="telefono">
                  <b-form-input
                      :disabled="true"
                      id="telefono"
                      size="sm"
                      v-model.trim="telefono"
                      placeholder=""
                  ></b-form-input>
                </b-form-group>
                <div class="col-12">
                  <div class="row">
                    <h5 class="col-12 section-title">{{$t('documents.titleDocuments')}}</h5>
                    <div v-if="personalIdType == 'pasaporte' || personalIdType == 'ine_ife'" class="col-6 mb-2">
                      <div class="h2 card m-2 p-1">
                        <b-icon-file-earmark-check class="rounded mx-auto" variant="success" />
                      </div>
                    </div>
                    <div v-if="personalIdType == 'ine_ife'" class="col-6 mb-2">
                      <div class="h2 card m-2 p-1">
                        <b-icon-file-earmark-check class="rounded mx-auto" variant="success" />
                      </div>
                    </div>
                  </div>
                </div>
          </div>
        <template #footer>
          <check-in-footer-middle step="sign" nextValue="FIRMAR"/>
        </template>
      </check-in-screen>
      </b-form>
</template>

<script>
import CheckInScreen from '@/components/layout/CheckInScreen'
import CheckInFooterMiddle from '@/components/footer/CheckInFooterMiddle'

import { mapState } from 'vuex'

export default {
  name: 'resume',
  components: {
    CheckInScreen,
    CheckInFooterMiddle
  },
  computed: {
    ...mapState(['reservation'])
  },
  data() {
    return {
      reservacion: '',
      fechaReservacion: '',
      entrada: '',
      salida: '',
      habitaciones: null,
      selected: false,
      show: true,
      nombreCompleto: '',
      correo: '',
      telefono: null,
      hasDocument: false,
      personalIdType: ''
    }
  },
  methods: {

    onChangeDataTitular(titular){
      this.telefono = titular.telefono
      this.correo = titular.correo
    },
    async getDataUser () {
      //this.$store.dispatch('getReservation').then((res) =>{
        const { 
          refId,
          resDate,
          startDate,
          endDate,
          rooms,
        } = this.$store.state.reservation;

        this.reservacion= refId
        this.fechaReservacion= resDate
        this.entrada= startDate
        this.salida= endDate
        this.habitaciones= rooms
      //})

      const idNewGuest = localStorage.getItem('idNewGuest')
      await this.$store.dispatch('sendBookData', {id:idNewGuest})
      const {
        name,
        lastName,
        email,
        phone,
        hasDocument,
        personalIdType
      } = this.$store.state.bookData;

      this.nombreCompleto = name + ' ' + lastName
      this.correo = email
      this.telefono = phone 
      this.hasDocument = hasDocument
      this.personalIdType = personalIdType
    },
    onSubmit(){
      this.$router.push('sign')
    }
  },
  created: function() {
    this.getDataUser()
  },
  mounted(){
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>